import { DesignButton, Typography } from 'components';
import styles from './ActionPlanCard.module.scss';
import c from 'classnames';
import actions from 'assets/images/home/actions.svg';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useNavigate } from 'react-router-dom';

export const ActionPlanCard = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const navigate = useNavigate();

  return (
    <div className={c(styles.card, styles.colorActions, 'hide-on-mobile')}>
      <div className={styles.contentContainer}>
        <Typography variant='heading-m'>View your full Action Plan</Typography>
        <DesignButton
          label='Take Action'
          width='full'
          color='purple'
          onClick={() => {
            navigate(`/action-plan/${currentKitId}`);
          }}
        />
      </div>
      <img src={actions} className={c(styles.cardImg, styles.actions)} />
    </div>
  );
};
